var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMixtureRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130.24168mm",
    height: "105.08385mm",
    viewBox: "0 0 130.24168 105.08385",
    id: "svg5",
    xmlSpace: "preserve",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    sodipodidocname: "mixture_red.svg",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    "inkscapedocument-units": "mm",
    showgrid: "false",
    inkscapezoom: 1.829812,
    inkscapecx: 320.25148,
    inkscapecy: 250.57219,
    "inkscapewindow-width": 2651,
    "inkscapewindow-height": 1177,
    "inkscapewindow-x": 237,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 0,
    "inkscapecurrent--layer": "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "bspline",
    id: "path-effect3773",
    is_visible: "true",
    lpeversion: 1,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false"
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "bspline",
    id: "path-effect3773-2",
    is_visible: "true",
    lpeversion: 1,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false"
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "bspline",
    id: "path-effect3773-2-7",
    is_visible: "true",
    lpeversion: 1,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false"
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "bspline",
    id: "path-effect3773-7",
    is_visible: "true",
    lpeversion: 1,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false"
  }))), /*#__PURE__*/React.createElement("g", {
    inkscapelabel: "Capa 1",
    inkscapegroupmode: "layer",
    id: "layer1",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeOpacity: 1
    },
    transform: "translate(-3.7791044,-3.0448028)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 3.5,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 16.843277,106.59702 16.870942,4.5454183",
    id: "path2790-2",
    sodipodinodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 3.5,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 132.49316,65.542601 5.3067342,65.564875",
    id: "path2790-2-7",
    sodipodinodetypes: "cc"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "3.52777px",
      fontFamily: "Acciona",
      InkscapeFontSpecification: "'Acciona, Normal'",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 160.35686,
    y: 38.679214,
    id: "text4503"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodirole: "line",
    id: "tspan4501",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 1,
      strokeOpacity: 1
    },
    x: 160.35686,
    y: 38.679214
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "18.4255px",
      fontFamily: "Acciona",
      InkscapeFontSpecification: "'Acciona, Normal'",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 1.10016,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 31.837519,
    y: 17.68844,
    id: "text4507"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodirole: "line",
    id: "tspan4505",
    style: {
      fontSize: "18.4255px",
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 1.10016,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 31.837519,
    y: 17.68844
  }, "Y = log(x)")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "17.2396px",
      fontFamily: "Acciona",
      InkscapeFontSpecification: "'Acciona, Normal'",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 1.02934,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 122.30637,
    y: 60.466339,
    id: "text4549"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodirole: "line",
    id: "tspan4547",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 1.02934,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 122.30637,
    y: 60.466339
  }, "X")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "16.5058px",
      fontFamily: "Acciona",
      InkscapeFontSpecification: "'Acciona, Normal'",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 0.985536,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 4.1912775,
    y: 14.433978,
    id: "text4553"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodirole: "line",
    id: "tspan4551",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 0.985536,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 4.1912775,
    y: 14.433978
  }, "Y")), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 3.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 27.767161,102.74965 C 32.480249,79.940109 37.19333,57.130605 54.472747,44.731492 71.752165,32.332379 101.59583,30.345099 131.43944,28.357823",
    id: "path3771",
    "inkscapepath-effect": "#path-effect3773",
    "inkscapeoriginal-d": "M 27.767161,102.74965 C 32.481016,79.940267 37.194095,57.130763 41.906683,34.31978 71.752206,32.332994 101.59587,30.345716 131.43944,28.357823",
    sodipodimodetypes: "ccc",
    "inkscapetransform-center-x": -3.3257059,
    "inkscapetransform-center-y": -15.182571
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 3.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 27.767161,28.357823 c 4.713088,22.809541 9.426167,45.61904 26.705586,58.018156 17.279418,12.399116 47.123083,14.386391 76.966693,16.373671",
    id: "path3771-3",
    "inkscapepath-effect": "#path-effect3773-7",
    "inkscapeoriginal-d": "m 27.767161,28.357823 c 4.713855,22.809382 9.426934,45.618882 14.139522,68.429872 29.845523,1.986784 59.689187,3.974065 89.532757,5.961955",
    sodipodinodetypes: "ccc",
    "inkscapetransform-center-x": -3.3257059,
    "inkscapetransform-center-y": 15.18257
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixtureRed);
export default __webpack_public_path__ + "static/media/mixture_red.0e01111d.svg";
export { ForwardRef as ReactComponent };